<div id="{{ componentId }}" class="vtr-ui-snapshot-list-info">
	<ul class="list-group modal-scroll">
		<li *ngFor="let item of componentList; let i = index"
			id="{{ componentId }}-item-{{ i }}"
			class="list-group-item"
			>
			<mat-accordion class="vtr-material-expansion-panel">
				<mat-expansion-panel
					panelId="{{ componentId }}-item-{{ i }}-subitems"
					[expanded]="item.collapsed"
					(opened)="item.collapsed = true"
					(closed)="item.collapsed = false">
					<mat-expansion-panel-header-customize class="component"
						[ngClass]="{'isSelected-item' : item.selected || item.indeterminate}"
						[aria-label]="('snapshot.' + item.name | translateDefault:item.name) + (item.collapsed ? '-collapse-subcomponents-list': '-expand-subcomponents-list')">
						<div class="custom-control">
							<vtr-material-checkbox
								[componentId]="componentId + '-item-' + i"
								[ariaLabel]="('snapshot.' + item.name + 'Title' | translateDefault:item.name) + '-checkbox'"
								[indeterminate]="item.indeterminate"
								(toggle)="onDeviceSelectionClicked(item, $event)"
								[checked]="item.selected"
								class="custom-control-component"
								[hasChild]="true"
							>
								<p id="{{ componentId }}-item-{{ i }}-name" role="text" class="custom-control-label-text name">
									{{ ('snapshot.' + item.name + 'Title') | translateDefault: item.name  }}
								</p>
							</vtr-material-checkbox>
						</div>
					</mat-expansion-panel-header-customize>
					<ng-template matExpansionPanelContent>
						<div id="{{ componentId }}-item-{{ i }}-subitems" class="sub-component">
							<ul class="list-group">
								<li *ngFor="let component of item.components; let j = index"
									id="{{ componentId }}-item-{{ i }}-subitem-{{ j }}"
									class="list-group-item"
									[ngClass]="{'isSelected-item' : component.selected}"
									>
									<div class="component">
										<div class="custom-control custom-checkbox">
											<vtr-material-checkbox
												componentId="{{ componentId }}-item-{{ i }}-subitem-{{ j }}"
												[ariaLabel]="('snapshot.components.' + component.name | translateDefault:component.name) + ('snapshot.' + component.name | translateDefault:component.name) + '-checkbox'"
												[checked]="component.selected"
												(toggle)="component.selected = $event; onCheckChildren(item)"
												class="custom-control-component"
												[hasChild]="true"
											>
												<p class="custom-control-label-text component-name" id="{{ componentId }}-item-{{ i }}-subitem-{{ j }}-name" role="text">
													{{ 'snapshot.components.' + component.name | translate }}
												</p>
											</vtr-material-checkbox>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</ng-template>
				</mat-expansion-panel>
			</mat-accordion>
		</li>
	</ul>
	<div class="options">
		<vtr-ui-hyperlink-button
			linkId="snapshot-select-all-components-link"
			hyperlinkStyle="xs-300-lightGray1"
			class="hyperlink-container"
			(hyperlinkClick)="onSelectAll()"
			[label]=" 'snapshot.select' | translate "
			[disableTooltip]="true"
			></vtr-ui-hyperlink-button>
		<span class="select-item-subtitle">/</span>
		<vtr-ui-hyperlink-button
			linkId="snapshot-deselect-all-components-link"
			hyperlinkStyle="xs-300-lightGray1"
			(hyperlinkClick)="onDeselectAll()"
			[label]=" 'snapshot.deselect' | translate "
			[disableTooltip]="true"
		></vtr-ui-hyperlink-button>
	</div>
</div>
